import { useEffect, useState } from 'react';
import { populate_LDB, clear_LDB, add_single_LDB, log_all_LDB, add_bulk_LDB } from '../../js functions/LDBfunctions';
import Papa from 'papaparse';   
import { app_single_entry, app_bulk_entry } from '../../js functions/APPfunctions'
import { useAuth } from '../../other/AuthContext';
import { convert_csv_to_data } from '../../js functions/csv_to_data';




const DBtester = () => {

    //variables and hook ------------------------------
    const { user, logoutUser } = useAuth();

    //LDB POPUPS
    const [is_single_LDB_visible, set_single_LDB_visible] = useState(false);
    const [is_bulk_LDB_Visible, set_bulk_LDB_Visible] = useState(false);

    //APPWRITE POPUPS
    const [is_single_app_Visible, set_single_app_Visible] = useState(false);
    const [is_bulk_app_visible, set_bulk_app_visible] = useState(false);

    //OTHERS
    const [LDB_obj, set_LDB_obj] = useState([]);
    const [APW_obj, set_APW_obj] = useState([]);
    const [file, setFile] = useState(null);
    const [formattedData, setFormattedData] = useState([]); //the csv parsed and formatted data gets stored in this.



    //useEffect
    useEffect(() => {
        const fetchData = async () => {
            try {
                const result = await populate_LDB(); // Await the result of populate_LDB

                setFormattedData(result); // Set the result to LDB_obj state
            } catch (e) {
                console.log('DBtester useEffect: ' + e);
            }
        };


        fetchData(); // Call the fetchData function

    }, []);  // Empty dependency array to run on mount



    //popup toggles 
    const toggle_single_LDB_Visible = () => { set_single_LDB_visible(!is_single_LDB_visible); };
    const toggle_bulk_LDB_Visible = () => { set_bulk_LDB_Visible(!is_bulk_LDB_Visible); };

    const toggle_single_APP_Visible = () => { set_single_app_Visible(!is_single_app_Visible); };
    const toggle_bulk_APP_Visible = () => { set_bulk_app_visible(!is_bulk_app_visible); };

    //-----------------------------------------APPWRITE CALL FUNCTIONS -------------------------------------------------

    async function appwrite_single_entry(e) {
        e.preventDefault();

        const payload = {
            title: e.target.title.value,                        // string
            start_time: new Date(e.target.start_time.value).toISOString, // datetime
            end_time: new Date(e.target.end_time.value).toISOString,    // datetime 
            description: e.target.description.value,            // string
            exercise_title: e.target.exercise_title.value,      // string
            set_index: parseInt(e.target.set_index.value),      // integer
            set_type: e.target.set_type.value,                  // string
            weight_kg: parseFloat(e.target.weight_kg.value),    // double (float)
            reps: parseInt(e.target.reps.value),                // integer
            user_id: user.$id,
        };

        app_single_entry([payload]);


        toggle_single_LDB_Visible();

        setFormattedData(await populate_LDB()); //updates the table

    }

    async function handle_app_BulkEntry(e) {
        e.preventDefault();

        app_bulk_entry(file, user.$id);

        toggle_bulk_APP_Visible();

    }

    //POPUPs handle
    async function open_appwrite_single_popup(e) {


        toggle_single_APP_Visible();

    }

    async function open_appwrite_bulk_popup(e) {


        toggle_bulk_APP_Visible();

    }


    //-----------------------------------------LDB CALL FUNCTIONS -------------------------------------------------


    //single entry
    async function handle_single_LDB(e) {
        e.preventDefault();
        add_single_LDB(e);
        toggle_single_LDB_Visible();

        setFormattedData(await populate_LDB()); //updates the table

    }

    //clear Local Database
    async function call_clear_LDB() {
        clear_LDB();
        setFormattedData(await populate_LDB()); //updates the table

    }


    async function refresh_LDB() {
        const refreshed_data = await populate_LDB(); // Fetch the data first
        console.log('LDB Refreshed:', refreshed_data); // Then log the data

        setFormattedData(refreshed_data); // Updates the state with the refreshed data
    }


    // Handle file drop
    const handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        const droppedFile = e.dataTransfer.files[0];
        if (droppedFile && droppedFile.type === 'text/csv') {
            setFile(droppedFile);
        } else {
            alert("Please drop a CSV file.");
        }
    };


    // Handle file selection via input
    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        if (selectedFile && selectedFile.type === 'text/csv') {
            setFile(selectedFile);
        } else {
            alert("Please select a CSV file.");
        }
    };

    async function handle_LDB_BulkEntry() {
        if (file) {


            Papa.parse(file, {
                complete: async (results) => {
                    try {
                        const processedData = results.data.map((row) => ({
                            ...row,
                            start_date: row.start_date ? new Date(row.start_date).toISOString() : null,
                            end_date: row.end_date ? new Date(row.end_date).toISOString() : null,
                            // Parse integers
                            superset_id: row.superset_id ? parseInt(row.superset_id, 10) : null,
                            set_index: row.set_index ? parseInt(row.set_index, 10) : null,
                            reps: row.reps ? parseInt(row.reps, 10) : null,
                            duration_seconds: row.duration_seconds ? parseInt(row.duration_seconds, 10) : null,
                            // Parse floats
                            weight_kg: row.weight_kg ? parseFloat(row.weight_kg) : null,
                            rpe: row.rpe ? parseFloat(row.rpe) : null,
                        }));

                        const result = await convert_csv_to_data(processedData);
                        setFormattedData(result);
                        console.log("Data to be stored in IndexedDB:", result);
                        add_bulk_LDB(result);
                        console.log('CONVERT COMPLETE');

                        //return processedData;
                        // setError('');
                    } catch (error) {
                        // setError('Error processing CSV data: ' + error.message);
                    }
                },
                header: true,
                skipEmptyLines: true,
                error: (error) => {
                    //   setError('Error parsing CSV: ' + error.message);
                },
            });





        } else {
            alert("No file selected.");
        }
    };

    async function handle_LDB_BulkEntry2() {
        if (file) {
            Papa.parse(file, {
                complete: (result) => {
                    console.log("Parsed CSV:", result);
                    const parsedData = result.data;

                    // Skip the first row (header) and format the data
                    const formattedData = parsedData.slice(1).map(row => ({
                        title: row[0],         // Assuming title is in the first column
                        start_time: row[1],    // Assuming start_time is in the second column
                        end_time: row[2],      // Assuming end_time is in the third column
                        description: row[3],   // Assuming description is in the fourth column
                        exercise_title: row[4], // Assuming exercise_title is in the fifth column
                        set_index: parseInt(row[5]),    // Assuming set_index is in the sixth column
                        set_type: row[6],      // Assuming set_type is in the seventh column
                        weight_kg: parseFloat(row[7]),  // Assuming weight_kg is in the eighth column
                        reps: parseInt(row[8]),         // Assuming reps is in the ninth column
                        user_id: toString(user.$id)       // Add user_id for each entry
                    }));

                    add_bulk_LDB(formattedData);

                    refresh_LDB();

                    toggle_bulk_LDB_Visible();

                    setFile(null);  // Reset file input after processing
                },
                header: false, // Ignore header row in the CSV
            });
        } else {
            alert("No file selected.");
        }
    };




    //-----------------------------------------RETURN -------------------------------------------------


    return (



        <div className=''>

            <div className='max_width'>

                <div className='userid_forcesync'>
                    <h1>Welcome {user ? user.name : 'Guest'}</h1>
                    <button>Force Sync</button>


                </div>


                <div className='box'>
                    <h2>Local Database</h2>

                    <div className='button_div'>

                        <button onClick={call_clear_LDB}>Clear Local</button>
                        <button onClick={toggle_single_LDB_Visible}>Add Single Entry</button>
                        <button onClick={toggle_bulk_LDB_Visible}>Bulk Entry</button>
                        <button onClick={log_all_LDB}>Console Log All</button>
                        <button onClick={refresh_LDB}>Refresh</button>


                    </div>

                    <div className='POPUP'>


                        {formattedData.length === 0 ? (
                            <p>No Data</p>
                        ) : (
                            <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                                <thead>
                                    <tr>
                                        <th  >Title</th>
                                        <th  >Start Time</th>
                                        <th  >End Time</th>
                                        {/* <th  >Description</th> */}
                                        <th  >Exercise Title</th>
                                        <th  >Sets</th>


                                    </tr>
                                </thead>
                                <tbody>
                                    {formattedData.map((item, index) => (
                                        <tr key={index}>
                                            <td  >{item.title}</td>
                                            <td>{item.start_time}</td>
                                            <td>{item.end_time}</td>
                                            {/* <td  >{item.description}</td> */}
                                            <td  >{item.exercise_title}</td>
                                            <td  >
                                                {item.sets.map((set, index) => (
                                                    <p key={index}>{`Set ${set.set_index}: ${set.weight_kg}kg x ${set.reps}`}</p>
                                                ))}
                                            </td>



                                        </tr>


                                    ))}
                                </tbody>
                            </table>
                        )}

                        {is_single_LDB_visible && (
                            <div className="popup-overlay">
                                <div className="popup-content">

                                    <div className='userid_forcesync'>
                                        <h2>Single Entry LDB</h2>
                                        <button onClick={toggle_single_LDB_Visible}>Close</button>
                                    </div>

                                    <form onSubmit={handle_single_LDB} className='form'>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="Workout Title"
                                            required
                                            defaultValue="Morning Workout"
                                        />
                                        <input
                                            type="datetime-local"
                                            name="start_time"
                                            placeholder="Start Time"
                                            required
                                            defaultValue={new Date().toISOString().slice(0, 16)}  // Set current date and time
                                        />
                                        <input
                                            type="datetime-local"
                                            name="end_time"
                                            placeholder="End Time"
                                            required
                                            defaultValue={new Date(Date.now() + 3600000).toISOString().slice(0, 16)}  // 1 hour later
                                        />
                                        <input
                                            type="text"
                                            name="description"
                                            placeholder="Description"
                                            defaultValue="Chest Day"  // Default value for description
                                        />
                                        <input
                                            type="text"
                                            name="exercise_title"
                                            placeholder="Exercise Title"
                                            defaultValue="Bench Press"  // Default exercise title
                                        />
                                        <input
                                            type="number"
                                            name="set_index"
                                            placeholder="Set Index"
                                            defaultValue="1"  // Default to first set
                                        />
                                        <input
                                            type="text"
                                            name="set_type"
                                            placeholder="Set Type"
                                            defaultValue="Strength"  // Default set type
                                        />
                                        <input
                                            type="number"
                                            name="weight_kg"
                                            placeholder="Weight (kg)"
                                            defaultValue="50"  // Default weight
                                        />
                                        <input
                                            type="number"
                                            name="reps"
                                            placeholder="Reps"
                                            defaultValue="10"  // Default reps
                                        />
                                        <button type="submit">Add Workout</button>
                                    </form>








                                </div>
                            </div>
                        )}

                        <div>
                            {is_bulk_LDB_Visible && (
                                <div className="popup-overlay">
                                    <div className="popup-content">
                                        <div className='userid_forcesync'>
                                            <h2>Bulk Entry LDB</h2>
                                            <button onClick={toggle_bulk_LDB_Visible}>Close</button>
                                        </div>

                                        <div
                                            className="drag-drop-container"
                                            onDrop={handleDrop}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{
                                                border: '2px dashed #ccc',
                                                padding: '20px',
                                                textAlign: 'center',
                                                marginBottom: '20px',
                                            }}
                                        >
                                            <p>Drag & Drop your CSV file here</p>
                                            <input
                                                type="file"
                                                accept=".csv"
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }}
                                                id="csvFileInput"
                                            />
                                            <label
                                                htmlFor="csvFileInput"
                                                style={{
                                                    display: 'inline-block',
                                                    padding: '10px 20px',
                                                    backgroundColor: '#4CAF50',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                Or choose file
                                            </label>
                                        </div>

                                        {file && <p>File selected: {file.name}</p>}

                                        <button onClick={handle_LDB_BulkEntry} style={{ marginTop: '20px' }}>
                                            Upload CSV
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>

                    </div>

                </div>






                <div className='box grey'>
                    <h2>Appwrite Database</h2>

                    <div className='button_div'>

                        <button>Clear Appwrite</button>
                        <button onClick={open_appwrite_single_popup} >Add Single Entry</button>
                        <button onClick={open_appwrite_bulk_popup}>Bulk Entry</button>
                        <button>Refresh</button>

                    </div>


                    {APW_obj.length === 0 ? (
                        <p>No Data</p>
                    ) : (
                        <table style={{ borderCollapse: 'collapse', width: '100%' }}>
                            <thead>
                                <tr>
                                    <th  >Title</th>
                                    <th  >Start Time</th>
                                    <th  >End Time</th>
                                    <th  >Description</th>
                                    <th  >Exercise Title</th>
                                    <th  >Set Index</th>
                                    <th  >Set Type</th>
                                    <th  >Weight (kg)</th>
                                    <th  >Reps</th>
                                    <th  >User ID</th>

                                </tr>
                            </thead>
                            <tbody>
                                {APW_obj.map((item, index) => (
                                    <tr key={index}>
                                        <td  >{item.title}</td>
                                        <td  >{item.start_time}</td>
                                        <td  >{item.end_time}</td>
                                        <td  >{item.description}</td>
                                        <td  >{item.exercise_title}</td>
                                        <td  >{item.set_index}</td>
                                        <td  >{item.set_type}</td>
                                        <td  >{item.weight_kg}</td>
                                        <td  >{item.reps}</td>
                                        <td  >{item.user_id}</td>
                                        <td  >{item.start_time}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    )}

                    <div className='appwrite_popups'>

                        {is_single_app_Visible && (
                            <div className="popup-overlay">
                                <div className="popup-content">

                                    <div className='userid_forcesync'>
                                        <h2>Single Entry Appwrite</h2>
                                        <button onClick={toggle_single_APP_Visible}>Close</button>
                                    </div>

                                    <form onSubmit={appwrite_single_entry} className='form'>
                                        <input
                                            type="text"
                                            name="title"
                                            placeholder="Workout Title"
                                            required
                                            defaultValue="Morning Workout"
                                        />
                                        <input
                                            type="datetime-local"
                                            name="start_time"
                                            placeholder="Start Time"
                                            required
                                            defaultValue={new Date().toISOString().slice(0, 16)}  // Set current date and time
                                        />
                                        <input
                                            type="datetime-local"
                                            name="end_time"
                                            placeholder="End Time"
                                            required
                                            defaultValue={new Date(Date.now() + 3600000).toISOString().slice(0, 16)}  // 1 hour later
                                        />
                                        <input
                                            type="text"
                                            name="description"
                                            placeholder="Description"
                                            defaultValue="Chest Day"  // Default value for description
                                        />
                                        <input
                                            type="text"
                                            name="exercise_title"
                                            placeholder="Exercise Title"
                                            defaultValue="Bench Press"  // Default exercise title
                                        />
                                        <input
                                            type="number"
                                            name="set_index"
                                            placeholder="Set Index"
                                            defaultValue="1"  // Default to first set
                                        />
                                        <input
                                            type="text"
                                            name="set_type"
                                            placeholder="Set Type"
                                            defaultValue="Strength"  // Default set type
                                        />
                                        <input
                                            type="number"
                                            name="weight_kg"
                                            placeholder="Weight (kg)"
                                            defaultValue="50"  // Default weight
                                        />
                                        <input
                                            type="number"
                                            name="reps"
                                            placeholder="Reps"
                                            defaultValue="10"  // Default reps
                                        />
                                        <button type="submit">Add Workout</button>
                                    </form>








                                </div>
                            </div>
                        )}



                        <div>
                            {is_bulk_app_visible && (

                                <div className="popup-overlay">
                                    <div className="popup-content">
                                        <div className='userid_forcesync'>
                                            <h2>Bulk Entry LDB</h2>
                                            <button onClick={toggle_bulk_APP_Visible}>Close</button>
                                        </div>

                                        <div
                                            className="drag-drop-container"
                                            onDrop={handleDrop}
                                            onDragOver={(e) => e.preventDefault()}
                                            style={{
                                                border: '2px dashed #ccc',
                                                padding: '20px',
                                                textAlign: 'center',
                                                marginBottom: '20px',
                                            }}
                                        >
                                            <p>Drag & Drop your CSV file here</p>

                                            <input
                                                type="file"
                                                accept=".csv"
                                                onChange={handleFileChange}
                                                style={{ display: 'none' }}
                                                id="csvFileInput"
                                            />
                                            <label
                                                htmlFor="csvFileInput"
                                                style={{
                                                    display: 'inline-block',
                                                    padding: '10px 20px',
                                                    backgroundColor: '#4CAF50',
                                                    color: 'white',
                                                    cursor: 'pointer',
                                                }}
                                            >
                                                Or choose file
                                            </label>
                                        </div>

                                        {file && <p>File selected: {file.name}</p>}

                                        <button onClick={handle_app_BulkEntry} style={{ marginTop: '20px' }}>
                                            Upload CSV
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>




                    </div>





                </div>










            </div>


        </div>






    );
}

export default DBtester;